import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { cidFromBuffer } from '@xyo-network/sdk-xyoworld-js'
import { Buffer } from 'buffer/'
// eslint-disable-next-line no-restricted-imports
import { FilePondFile } from 'filepond'
import { useState } from 'react'
import { FilePond, registerPlugin } from 'react-filepond'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const FilePondPluginImageExifOrientation = require('filepond-plugin-image-exif-orientation')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const FilePondPluginImagePreview = require('filepond-plugin-image-preview')

interface EditImageDialogProps {
  onCancel?: () => void
  onSave?: (cid: string, bytes: Buffer) => void
  open?: boolean
}

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

const EditImageDialogOpen: React.FC<EditImageDialogProps> = (props) => {
  const { onCancel, onSave, open = false } = props
  const [files, setFiles] = useState<FilePondFile[]>([])

  const onSaveClicked = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    const fileBuffer = await files[0].file.arrayBuffer()
    const bytes = Buffer.from(fileBuffer)
    const cid = await cidFromBuffer(bytes)
    onSave?.(cid.toString(), bytes)
  }

  return (
    <Dialog onClose={onCancel} open={open}>
      <DialogTitle>Edit</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" minWidth={300}>
          <FilePond
            allowMultiple={false}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            files={files as any}
            labelIdle={'Drag & Drop your files or <span class="filepond--label-action">Browse</span>'}
            maxFiles={1}
            name="files"
            onupdatefiles={setFiles}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box>
            <Button onClick={onCancel} variant="text">
              Cancel
            </Button>
          </Box>
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={onSaveClicked} variant="text">
              Save
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const EditImageDialog: React.FC<EditImageDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <EditImageDialogOpen {...props} />
  } else {
    return null
  }
}

export default EditImageDialog
